import { formatResultsDate } from "../../../../../functions/functions";
import "./middleBodyResults.sass";

export default function MiddleBodyResults({ date, left_class, right_class, clase, left_score, right_score }) {

  //ganador: clarosports-winner ; perdedor: clarosports-loser
  const getScoreClass = (baseClass, teamClass) =>
    `${baseClass} ${teamClass === 'clarosports-winner' ? 'score-ganador' : 'score-perdedor'}`;
  //finalizado: clarosports-finished-game ; error: clarosports-error-game ; proximo: clarosports-next-game ; envivo: clarosports-in-progress-game

  return (
    <div className="results__body-middle">
      {clase === 'clarosports-next-game' &&
        <div className="results__body-middle-next">
          <span className="body-date">{formatResultsDate(date)}</span>
        </div>
      }

      {(clase === 'clarosports-finished-game' || clase === 'clarosports-in-progress-game') &&
        <div className="results__body-middle-score">
          <div className={getScoreClass('results__body-middle-score__scoreL', left_class)}>{left_score}</div>
          <div className={getScoreClass('results__body-middle-score__scoreR', right_class)}>{right_score}</div>
        </div>
      }
    </div>
  )
}